import { v4 as uuidv4 } from 'uuid';
import type { LinkedItem } from 'venn-api';

export const getRandomId = uuidv4;

export enum LinkedField {
  'SUBJECTS' = 'SUBJECTS',
  'BENCHMARK' = 'BENCHMARK',
  'DATERANGE' = 'DATERANGE',
}

export const getDefaultLinkedField = (refId: string): LinkedItem[] => [
  {
    refBlockId: refId,
    refField: LinkedField.SUBJECTS,
    refOutput: false,
    field: LinkedField.SUBJECTS,
  },
  {
    refBlockId: refId,
    refField: LinkedField.BENCHMARK,
    refOutput: false,
    field: LinkedField.BENCHMARK,
  },
  {
    refBlockId: refId,
    refField: LinkedField.DATERANGE,
    refOutput: false,
    field: LinkedField.DATERANGE,
  },
];
